import './conversions-filter.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';

const Form = ({ intl, apply }) => (
	<form className="conversions-filter" onSubmit={apply}>
		<div className="conversions-filter__element">
			<Field name="conversionsFrom" placeholder={intl('Leads from')} showLabel={false} component={InputField} />
		</div>
	</form>
);

Form.propTypes = {
	intl: PropTypes.func,
	apply: PropTypes.func
};

export default reduxForm({
	form: 'conversionsFromAffiliatesRedeem'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-redeem/components/form/conversions-filter.js